import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateContactRequest extends BaseUpdateRequest {
	firstName = '';  
	lastName = '';
    emailAddress = '';
    jobTitle = '';
    positionId = '';
    mobilePhoneNumber = '';
    otherPhoneNumber = '';
    isAgreedToMarketing = false;
    // canManageProfile: boolean;
    // canManageReports: boolean;
    // canManageUsers: boolean;
    // canManageRoles: boolean;
    // canManageLocations: boolean;
    // canManageBookings: boolean;
    // canManageWorkers: boolean;
    // canManageTimesheets: boolean;			
}